export default "__VITE_ASSET__CLnoavLz__"